(function () {
  var root = document.querySelector('[data-fa-quiz]');
  if (!root) return;

  var FLOW_ID = root.getAttribute('data-flow') || '';
  var FLOWS = window.FA_QUIZ_FLOWS || {};
  var FLOW = FLOWS[FLOW_ID];
  if (!FLOW) return;

  var REDIRECT_URL = root.getAttribute('data-redirect-url') || FLOW.redirectUrl || '';
  var ADVANCE_DELAY = 230;

  function isMobileMq() {
    return !!(window.matchMedia && window.matchMedia('(max-width: 749px)').matches);
  }

  /* Figma ring frame 245:8996 (desktop) / 245:9037 (mobile): a square box with a
     track stroke sitting inside it and a tinted inner disc.
       desktop  box 200, stroke 12 -> r 94, disc 152 across (r 76)
       mobile   box 120, stroke  8 -> r 56, disc  92 across (r 46) */
  function ringGeom() {
    var m = isMobileMq();
    var box = m ? 120 : 200;
    var sw = m ? 8 : 12;
    return { box: box, sw: sw, r: (box - sw) / 2, disc: m ? 46 : 76 };
  }

  function ringCirc(el) {
    if (el && el.r && el.r.baseVal) return 2 * Math.PI * el.r.baseVal.value;
    return 2 * Math.PI * ringGeom().r;
  }

  var STEPS = FLOW.steps;
  var TIERS = FLOW.tiers;
  var SCORING = FLOW.scoring;

  var PROGRESS_TYPES = { hero: 1, question: 1, interstitial: 1, ring_loader: 1 };
  var PROGRESS_TOTAL = 1;
  STEPS.forEach(function (s, i) {
    if (PROGRESS_TYPES[s.type]) PROGRESS_TOTAL = i + 1;
  });

  /* Figma advances the bar one slot per *visible* screen: 245:8892 is 11/13 on
     s11 and 245:9063 is 12/13 on s12, even though a ring_loader sits between
     them. So a ring_loader counts toward the denominator but does not consume a
     slot in the numerator. */
  var PROGRESS_POS = (function () {
    var pos = 0;
    return STEPS.map(function (s) {
      if (PROGRESS_TYPES[s.type] && s.type !== 'ring_loader') pos++;
      return pos;
    });
  })();

  var QUESTION_ORDER = STEPS.filter(function (s) { return s.q; }).map(function (s) { return s.q; });

  var state = { screen: 0, answers: {}, answerText: {}, score: 0, tier: 'low', started: false };

  var ARROW_IMG = '<img src="' + (root.getAttribute('data-arrow-icon') || '') + '" alt="">';
  var VERIFIED_IMG = '<span class="fq-vicon"><img src="' + (root.getAttribute('data-verified-icon') || '') + '" alt=""></span>';

  /* Figma lightbulb-05 (79:1107) as placed in the "why we ask" container: a
     29.3333 glyph centred in a 32 box (4.17% inset), fill Secondary/Orange. */
  var LIGHTBULB_SVG = '<svg viewBox="-1.3333 -1.3333 32 32" fill="none" aria-hidden="true" focusable="false" xmlns="http://www.w3.org/2000/svg">' +
    '<path d="M16 1.33333C16 0.596954 15.403 0 14.6667 0C13.9303 0 13.3333 0.596954 13.3333 1.33333V2.66667C13.3333 3.40305 13.9303 4 14.6667 4C15.403 4 16 3.40305 16 2.66667V1.33333Z" fill="#F0AD4E"/>' +
    '<path d="M1.33333 13.3333C0.596954 13.3333 0 13.9303 0 14.6667C0 15.403 0.596954 16 1.33333 16H2.66667C3.40305 16 4 15.403 4 14.6667C4 13.9303 3.40305 13.3333 2.66667 13.3333H1.33333Z" fill="#F0AD4E"/>' +
    '<path d="M4.25706 4.25706C4.77776 3.73636 5.62198 3.73636 6.14268 4.25706L6.94281 5.05719C7.46351 5.57789 7.46351 6.42211 6.94281 6.94281C6.42211 7.46351 5.57789 7.46351 5.05719 6.94281L4.25706 6.14268C3.73636 5.62198 3.73636 4.77776 4.25706 4.25706Z" fill="#F0AD4E"/>' +
    '<path d="M25.0764 6.1428C25.5971 5.62216 25.5972 4.77794 25.0766 4.25718C24.556 3.73642 23.7117 3.73631 23.191 4.25694L22.3906 5.05707C21.8699 5.57771 21.8698 6.42193 22.3904 6.94269C22.911 7.46346 23.7553 7.46356 24.276 6.94293L25.0764 6.1428Z" fill="#F0AD4E"/>' +
    '<path d="M25.3333 14.6667C25.3333 13.9303 25.9303 13.3333 26.6667 13.3333H28C28.7364 13.3333 29.3333 13.9303 29.3333 14.6667C29.3333 15.403 28.7364 16 28 16H26.6667C25.9303 16 25.3333 15.403 25.3333 14.6667Z" fill="#F0AD4E"/>' +
    '<path fill-rule="evenodd" clip-rule="evenodd" d="M14.6667 5.33333C9.51201 5.33333 5.33333 9.51201 5.33333 14.6667C5.33333 17.5377 6.63074 20.1057 8.66667 21.8161L8.66667 23.7847C8.66664 24.4876 8.66662 25.0939 8.70743 25.5934C8.75049 26.1205 8.84558 26.6448 9.10264 27.1493C9.48613 27.9019 10.0981 28.5139 10.8507 28.8974C11.3552 29.1544 11.8795 29.2495 12.4066 29.2926C12.9061 29.3334 13.5124 29.3334 14.2152 29.3333H15.1181C15.8209 29.3334 16.4273 29.3334 16.9267 29.2926C17.4538 29.2495 17.9781 29.1544 18.4826 28.8974C19.2353 28.5139 19.8472 27.9019 20.2307 27.1493C20.4878 26.6448 20.5828 26.1205 20.6259 25.5934C20.6667 25.0939 20.6667 24.4876 20.6667 23.7847V21.8161C22.7026 20.1057 24 17.5377 24 14.6667C24 9.51201 19.8213 5.33333 14.6667 5.33333ZM10.6667 16.6667C10.6667 15.9303 11.2636 15.3333 12 15.3333H17.3333C18.0697 15.3333 18.6667 15.9303 18.6667 16.6667C18.6667 17.403 18.0697 18 17.3333 18H16V23.3333C16 24.0697 15.403 24.6667 14.6667 24.6667C13.9303 24.6667 13.3333 24.0697 13.3333 23.3333V18H12C11.2636 18 10.6667 17.403 10.6667 16.6667Z" fill="#F0AD4E"/>' +
    '</svg>';
  /* Figma "clock" (226:4106) as placed in the urgency pill 245:9293 — a 22 glyph
     centred in a 24 box (4.17% inset), Secondary red. */
  var CLOCK_SVG = '<svg viewBox="-1 -1 24 24" fill="none" aria-hidden="true" focusable="false" xmlns="http://www.w3.org/2000/svg">' +
    '<path fill-rule="evenodd" clip-rule="evenodd" d="M0 11C0 4.92487 4.92487 0 11 0C17.0751 0 22 4.92487 22 11C22 17.0751 17.0751 22 11 22C4.92487 22 0 17.0751 0 11ZM12 5C12 4.44772 11.5523 4 11 4C10.4477 4 10 4.44772 10 5V11C10 11.3788 10.214 11.725 10.5528 11.8944L14.5528 13.8944C15.0468 14.1414 15.6474 13.9412 15.8944 13.4472C16.1414 12.9532 15.9412 12.3526 15.4472 12.1056L12 10.382V5Z" fill="currentColor"/></svg>';

  var GID = String(FLOW_ID).replace(/[^a-z0-9]/gi, '') || 'fq';
  var ID_RING = 'fqRingGrad-' + GID;
  var ID_STEP = 'fqStepGrad-' + GID;
  var ID_AREA = 'fqArea-' + GID;
  var ID_TRACE = 'fqTrace-' + GID;
  var ID_BADGE = 'fqBadge-' + GID;

  function clampScreen(n) {
    if (typeof n !== 'number' || !isFinite(n)) return 0;
    return Math.max(0, Math.min(STEPS.length - 1, Math.floor(n)));
  }

  var qs = new URLSearchParams(window.location.search);
  /* QA deep links. Out-of-range / non-numeric ?fqs= must never leave a blank
     stage — clamp into [0, STEPS.length - 1] instead. */
  if (qs.get('fqs') !== null) state.screen = clampScreen(parseInt(qs.get('fqs'), 10));
  if (qs.get('fqt') !== null && TIERS[qs.get('fqt')]) state.tier = qs.get('fqt');

  function questionId(key) {
    var idx = QUESTION_ORDER.indexOf(key);
    return idx === -1 ? key : 'question_' + (idx + 1);
  }

  function sendToKlaviyo() {
    if (!window.klaviyo || typeof window.klaviyo.push !== 'function') return;
    var props = { quiz_source: 'Quiz', quiz_flow: FLOW_ID, quiz_score: state.score, quiz_tier: state.tier };
    QUESTION_ORDER.forEach(function (q, idx) {
      if (state.answerText[q]) props['quiz_q' + (idx + 1)] = state.answerText[q];
    });
    try {
      window.klaviyo.push(['identify', props]);
      window.klaviyo.push(['track', FLOW.klaviyoEvent || 'Quiz Completed', props]);
    } catch (e) {}
  }

  /* Event names and parameters are identical to the OMNI quiz. The transport
     differs by necessity: OMNI pushed gtag-style `['event', name, params]` and
     gated it on a dataLayer `config` entry, which only gtag.js writes. This
     store loads GTM (gtm.js) and never writes one, so that path would queue
     every event and then silently discard the lot. GTM's own custom-event form
     is an object push, which GTM also replays for anything pushed before
     gtm.js finishes loading — so no queue is needed. */
  function track(eventName, params) {
    var payload = params || {};
    payload.quiz_flow = FLOW_ID;
    var plain = {};
    Object.keys(payload).forEach(function (key) {
      if (typeof payload[key] !== 'function') plain[key] = payload[key];
    });
    try {
      window.dataLayer = window.dataLayer || [];
      var dlEvent = { event: eventName };
      Object.keys(plain).forEach(function (key) { dlEvent[key] = plain[key]; });
      window.dataLayer.push(dlEvent);

      if (window.Shopify && window.Shopify.analytics && typeof window.Shopify.analytics.publish === 'function') {
        window.Shopify.analytics.publish(eventName, plain);
      }
      if (typeof window.clarity === 'function') {
        window.clarity('event', eventName);
        Object.keys(plain).forEach(function (key) {
          window.clarity('set', eventName + '_' + key, String(plain[key]));
        });
      }
    } catch (e) {}
  }

  function matchesRule(cond, answers) {
    var keys = Object.keys(cond);
    for (var i = 0; i < keys.length; i++) {
      var a = answers[keys[i]];
      if (a === undefined) return false;
      var want = cond[keys[i]];
      if (Array.isArray(want)) {
        if (want.indexOf(a) === -1) return false;
      } else if (want !== a) {
        return false;
      }
    }
    return true;
  }

  function scoreAnswers(answers) {
    var total = 0;
    Object.keys(SCORING.map).forEach(function (q) {
      var a = answers[q];
      if (a === undefined) return;
      var pts = SCORING.map[q][a];
      if (typeof pts === 'number') total += pts;
    });
    return total;
  }

  function resolveTier(score, answers) {
    var rules = SCORING.overrides || [];
    var i;
    for (i = 0; i < rules.length; i++) {
      if (rules[i].force && matchesRule(rules[i].when, answers)) return rules[i].force;
    }
    var tier = SCORING.tiers[SCORING.tiers.length - 1].id;
    for (i = 0; i < SCORING.tiers.length; i++) {
      if (score >= SCORING.tiers[i].min) { tier = SCORING.tiers[i].id; break; }
    }
    for (i = 0; i < rules.length; i++) {
      if (rules[i].force) continue;
      if (rules[i].fromTier === tier && matchesRule(rules[i].when, answers)) tier = rules[i].toTier;
    }
    return tier;
  }

  function calcTier() {
    state.score = scoreAnswers(state.answers);
    state.tier = resolveTier(state.score, state.answers);
  }

  window.FA_QUIZ_SCORE = function (answers) {
    var s = scoreAnswers(answers);
    return { score: s, tier: resolveTier(s, answers) };
  };

  function esc(t) {
    return String(t).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;');
  }

  function optionsHtml(question, options) {
    return '<div class="fq-options">' + options.map(function (o, i) {
      return '<button type="button" class="fq-option" data-q="' + question + '" data-i="' + i + '">' + esc(o) + '</button>';
    }).join('') + '</div>';
  }

  function testimonialCard(t, extraClass) {
    return '<div class="fq-card fq-testimonial ' + (extraClass || '') + '">' +
      '<p class="fq-testimonial-text">"' + esc(t.text) + '"</p>' +
      '<div class="fq-testimonial-meta">' +
      '<span class="fq-avatar">' + esc(t.initial) + '</span>' +
      '<span class="fq-testimonial-name">' + esc(t.name) + '</span>' +
      '<span class="fq-verified">' + VERIFIED_IMG + esc(t.badge || 'Verified Review') + '</span>' +
      '</div></div>';
  }

  function whyBox(text) {
    return '<div class="fq-card fq-why">' +
      '<div class="fq-why-head"><span class="fq-why-icon">' + LIGHTBULB_SVG + '</span>' +
      '<p class="fq-why-label">WHY WE ASK</p></div>' +
      '<p class="fq-why-text">' + esc(text) + '</p></div>';
  }

  function centred(inner, cls) {
    return '<div class="' + cls + '" style="width:100%;display:flex;justify-content:center;">' + inner + '</div>';
  }

  function title(raw) {
    return String(raw).replace(/<br\s*\/?>/gi, '<br class="fq-brk">');
  }

  function questionScreen(step) {
    var html = '';
    var d = 1;
    html += '<h1 class="fq-h1' + (step.titleWide ? ' fq-h1--wide' : '') +
      ' fq-fade-up fq-d' + d + '">' + title(step.title) + '</h1>'; d++;
    if (step.sub) { html += '<p class="fq-sub fq-fade-up fq-d' + d + '">' + title(step.sub) + '</p>'; d++; }
    html += centred(optionsHtml(step.q, step.options), 'fq-fade-up fq-d' + d); d++;
    if (step.helper) { html += '<p class="fq-helper fq-fade-up fq-d' + d + '">' + esc(step.helper) + '</p>'; d++; }
    if (step.why) { html += centred(whyBox(step.why), 'fq-fade-up fq-d' + d); }
    return html;
  }

  function heroScreen(step) {
    return '<h1 class="fq-h1 fq-fade-up fq-d1">' + title(step.title) + '</h1>' +
      '<p class="fq-sub fq-fade-up fq-d2">' + title(step.sub) + '</p>' +
      centred(testimonialCard(step.testimonial), 'fq-hero-card fq-fade-up fq-d3 fq-pull-32') +
      '<h2 class="fq-h1 fq-qlabel fq-fade-up fq-d4">' + title(step.qLabel) + '</h2>' +
      centred(optionsHtml(step.q, step.options), 'fq-fade-up fq-d5');
  }

  function interstitialScreen(step) {
    return '<h1 class="fq-h1 fq-fade-up fq-d1">' + title(step.title) + '</h1>' +
      '<p class="fq-sub fq-fade-up fq-d2">' + title(step.sub) + '</p>' +
      centred('<button type="button" class="fq-cta" data-continue>' + esc(step.cta) + '</button>', 'fq-fade-up fq-d3') +
      '<div class="fq-testimonial-row fq-fade-up fq-d4">' +
      step.testimonials.map(function (t) { return testimonialCard(t); }).join('') +
      '</div>';
  }

  /* Figma "check-circle" (2:5534) as placed in the step rows (245:9165): a 44
     glyph centred in the 48 icon box (4.17% inset), Secondary/Green solid disc
     with the tick knocked out. */
  var STEP_CHECK_SVG = '<svg viewBox="-2 -2 48 48" fill="none" aria-hidden="true" focusable="false" xmlns="http://www.w3.org/2000/svg">' +
    '<path fill-rule="evenodd" clip-rule="evenodd" d="M22 0C9.84974 0 0 9.84974 0 22C0 34.1503 9.84974 44 22 44C34.1503 44 44 34.1503 44 22C44 9.84974 34.1503 0 22 0ZM32.4142 17.4142C33.1953 16.6332 33.1953 15.3668 32.4142 14.5858C31.6332 13.8047 30.3668 13.8047 29.5858 14.5858L19 25.1716L14.4142 20.5858C13.6332 19.8047 12.3668 19.8047 11.5858 20.5858C10.8047 21.3668 10.8047 22.6332 11.5858 23.4142L17.5858 29.4142C18.3668 30.1953 19.6332 30.1953 20.4142 29.4142L32.4142 17.4142Z" fill="#338411"/></svg>';

  /* Figma "Ellipse 6" on the in-progress step row (245:9183): r 21 inside the 48
     box, 6 stroke, round cap, 290.9deg sweep, #89E164 -> #338411 diagonal. */
  function stepSpinSvg() {
    var C = 2 * Math.PI * 21;
    return '<svg viewBox="0 0 48 48" fill="none" aria-hidden="true" focusable="false" xmlns="http://www.w3.org/2000/svg">' +
      '<defs><linearGradient id="' + ID_STEP + '" x1="0" y1="0" x2="1" y2="1">' +
      '<stop offset="0%" stop-color="#89E164"/><stop offset="100%" stop-color="#338411"/>' +
      '</linearGradient></defs>' +
      '<circle cx="24" cy="24" r="21" fill="none" stroke="url(#' + ID_STEP + ')" stroke-width="6" stroke-linecap="round"' +
      ' stroke-dasharray="' + (C * 0.808).toFixed(2) + ' ' + C.toFixed(2) + '"/></svg>';
  }

  function stepCard(step, iconState) {
    var icon;
    if (iconState === 'done') icon = '<span class="fq-step-icon fq-step-icon--done">' + STEP_CHECK_SVG + '</span>';
    else if (iconState === 'active') icon = '<span class="fq-step-icon fq-step-icon--active">' + stepSpinSvg() + '</span>';
    else icon = '<span class="fq-step-num">' + esc(step.num == null ? '' : step.num) + '</span>';
    return '<div class="fq-step" data-step>' + icon +
      '<div class="fq-step-text"><h4>' + esc(step.title) + '</h4><p>' + esc(step.text) + '</p></div></div>';
  }

  function ringValueHtml(v) {
    var s = String(v);
    if (s.charAt(s.length - 1) === '%') return esc(s.slice(0, -1)) + '<span class="fq-ring-pct">%</span>';
    return esc(s);
  }

  function ringHtml(centerValue, centerLabel) {
    var g = ringGeom();
    var c = 2 * Math.PI * g.r;
    var mid = g.box / 2;
    return '<div class="fq-ring-wrap">' +
      '<svg class="fq-ring-svg" viewBox="0 0 ' + g.box + ' ' + g.box + '">' +
      /* Figma paints the arc top-left -> bottom-right; the svg is rotated -90deg
         so the gradient vector is rotated back by +90deg here. */
      '<defs><linearGradient id="' + ID_RING + '" x1="1" y1="0" x2="0" y2="1">' +
      '<stop offset="0%" stop-color="#3B82F6"/>' +
      '<stop offset="100%" stop-color="#004AAD"/>' +
      '</linearGradient></defs>' +
      '<circle class="fq-ring-disc" cx="' + mid + '" cy="' + mid + '" r="' + g.disc + '"/>' +
      '<circle class="fq-ring-track" cx="' + mid + '" cy="' + mid + '" r="' + g.r + '" stroke-width="' + g.sw + '"/>' +
      '<circle class="fq-ring-fg" cx="' + mid + '" cy="' + mid + '" r="' + g.r + '" stroke-width="' + g.sw + '" stroke="url(#' + ID_RING + ')" stroke-dasharray="' + c + '" stroke-dashoffset="' + c + '" data-ring/>' +
      '</svg>' +
      '<div class="fq-ring-center"><span class="fq-ring-value" data-ring-value>' + ringValueHtml(centerValue) + '</span>' +
      (centerLabel ? '<span class="fq-ring-label">' + esc(centerLabel) + '</span>' : '') +
      '</div></div>';
  }

  function ringLoaderScreen(step) {
    return '<div class="fq-fade-up fq-d1">' + ringHtml('0%', step.ringLabel || '') + '</div>' +
      '<h1 class="fq-h1 fq-fade-up fq-d2 fq-pull-32">' + title(step.title) + '</h1>' +
      '<p class="fq-sub fq-fade-up fq-d3 fq-pull-32">' + esc(step.sub) + '</p>' +
      '<div class="fq-dots fq-fade-up fq-d4"><span class="fq-dot is-active"></span><span class="fq-dot"></span><span class="fq-dot"></span></div>';
  }

  function stepLoaderScreen(step) {
    if (step.variant === 'ring') {
      return '<div class="fq-fade-up fq-d1">' + ringHtml('1/' + step.steps.length, '') + '</div>' +
        '<h1 class="fq-h1 fq-fade-up fq-d2 fq-pull-32">' + title(step.title) + '</h1>' +
        '<p class="fq-sub fq-fade-up fq-d3">' + esc(step.sub) + '</p>' +
        '<div class="fq-steps fq-fade-up fq-d4" data-steps></div>' +
        (step.urgency ? '<div class="fq-fade-up fq-d5"><span class="fq-urgency">' + CLOCK_SVG + esc(step.urgency) + '</span></div>' : '');
    }
    return '<h1 class="fq-h1 fq-fade-up fq-d1">' + title(step.title) + '</h1>' +
      '<p class="fq-sub fq-fade-up fq-d2">' + esc(step.sub) + '</p>' +
      '<div class="fq-steps fq-fade-up fq-d3" data-steps></div>' +
      '<div class="fq-step-footer fq-fade-up fq-d4"><span data-step-count>Step 1 of ' + step.steps.length + '</span>' +
      '<div class="fq-mini-progress"><div class="fq-mini-progress-fill" data-step-progress style="width:' + (100 / step.steps.length) + '%"></div></div></div>';
  }

  function gaugeHtml(t) {
    var labels = FLOW.gauge.labels;
    var segs = ['depleted', 'low', 'normal', 'optimal'];
    var needle = '<div class="fq-gauge-needle"><img src="' + (root.getAttribute('data-needle-icon') || '') + '" alt=""></div>';
    return '<div class="fq-rescard fq-gauge-card">' +
      '<div><p class="fq-gauge-title">' + esc(FLOW.gauge.title) + '</p>' +
      '<div class="fq-gauge-cols">' + labels.map(function (l, i) {
        var active = i === t.activeSegment;
        return '<div class="fq-gauge-col' + (active ? ' is-active' : '') + '">' +
          '<div class="fq-gauge-col-top">' + (active ? needle : '') +
          '<div class="fq-gauge-seg fq-gauge-seg--' + segs[i] + '"></div></div>' +
          '<span>' + esc(l) + '</span></div>';
      }).join('') + '</div></div>' +
      '<div class="fq-gauge-foot">' +
      '<p class="fq-gauge-level">' + esc(FLOW.gauge.scoreLabel || 'Your score:') + ' <strong class="fq-tier-accent">' + esc(t.levelLabel) + '</strong></p>' +
      '<span class="fq-pct-pill fq-tier-accent">' + esc(t.pct) + '</span>' +
      '</div></div>';
  }

  /* Geometry transcribed from Figma "Graph" 245:4096 (desktop 582x275) and
     "Review Card Content" 245:4184 (mobile 328x196). Every literal below is a
     measured node offset, not a guess — see the QA notes in fa-quiz.css. */
  var CHART_GEO = {
    d: {
      W: 582, H: 275, padL: 79, plotR: 573, traceR: 570, endDotX: 562,
      rowY: [15, 88.6667, 162.3333, 236], endY: 15,
      yBase: [19.64, 91.64, 163.64, 235.64], xBase: 267.64,
      xw: [37, 63, 63, 63], labelSpan: 503,
      startNudge: 6, pinDX: 6, pinR: 8, pinHaloR: 12,
      endR: 6, endHaloR: 12,
      calloutW: 104, calloutH: 35, calloutDX: -6, calloutGap: 4,
      badgeW: 73, badgeH: 30, badgeX: 520, badgeY: -32,
      gradTop: -262, gradBottom: 217.5
    },
    m: {
      W: 328, H: 196, padL: 61, plotR: 321, traceR: 319, endDotX: 312,
      rowY: [11, 62, 113, 164], endY: 21,
      yBase: [15.28, 65.61, 115.95, 166.28], xBase: 190.28,
      xw: [29, 50, 50, 50], labelSpan: 267,
      startNudge: 1, pinDX: 3.5, pinR: 6, pinHaloR: 10,
      endR: 4, endHaloR: 10,
      calloutW: 79, calloutH: 25, calloutDX: -6.5, calloutGap: 4,
      badgeW: 60, badgeH: 25, badgeX: 287, badgeY: -18,
      gradTop: -172, gradBottom: 153
    }
  };

  function chartHtml(t) {
    var mob = window.matchMedia && window.matchMedia('(max-width: 749px)').matches;
    var g = mob ? CHART_GEO.m : CHART_GEO.d;
    var W = g.W, H = g.H, padL = g.padL;
    var yLabels = FLOW.chart.yLabels;
    var xLabels = FLOW.chart.xLabels || ['Now', '30 days', '60 days', '90 days'];
    var rows = 4;
    var bottomRow = g.rowY[rows - 1];
    var startY = g.rowY[t.chartStartY];
    if (t.chartStartY === rows - 1) startY = bottomRow - g.startNudge;
    var endY = g.endY;
    var startX = padL + 2;
    var endX = g.traceR;
    var dx = endX - startX, dy = startY - endY;
    /* Figma draws a deeper S for the bottom-row start (245:4112) and a shallower
       one for the two upper starts (245:4388 / 245:4666) */
    var cf = t.chartStartY === rows - 1
      ? [0.6155, 0.7203, 0.5198, 0.0655]
      : [0.2352, 0.8435, 0.5440, 0.1531];
    var cax = startX + cf[0] * dx, cay = endY + cf[1] * dy;
    var cbx = startX + cf[2] * dx, cby = endY + cf[3] * dy;
    var path = 'M ' + startX + ' ' + startY + ' C ' + cax + ' ' + cay + ', ' + cbx + ' ' + cby + ', ' + endX + ' ' + endY;
    var areaPath = 'M ' + startX + ' ' + startY + ' C ' + cax + ' ' + cay + ', ' + cbx + ' ' + cby + ', ' + g.plotR + ' ' + endY +
      ' L ' + g.plotR + ' ' + bottomRow + ' L ' + startX + ' ' + bottomRow + ' Z';
    var grid = '';
    var labels = '';
    for (var i = 0; i < rows; i++) {
      grid += '<line class="fq-chart-grid-line" style="animation-delay:' + (250 + i * 80) + 'ms" x1="' + padL + '" y1="' + g.rowY[i] + '" x2="' + g.plotR + '" y2="' + g.rowY[i] + '"/>';
      labels += '<text class="fq-chart-label" style="animation-delay:' + (600 + i * 60) + 'ms" x="0" y="' + g.yBase[i] + '" text-anchor="start">' + esc(yLabels[i]) + '</text>';
    }
    var xw = g.xw;
    var xgap = (g.labelSpan - (xw[0] + xw[1] + xw[2] + xw[3])) / 3;
    var xpos = padL;
    for (var j = 0; j < xLabels.length; j++) {
      var gx = j === 0 ? padL : j === xLabels.length - 1 ? W : xpos + xw[j] / 2;
      labels += '<text class="fq-chart-label" style="animation-delay:' + (500 + j * 60) + 'ms" x="' + gx + '" y="' + g.xBase + '" text-anchor="' + (j === 0 ? 'start' : j === xLabels.length - 1 ? 'end' : 'middle') + '">' + esc(xLabels[j]) + '</text>';
      xpos += xw[j] + xgap;
    }
    var pinX = padL + g.pinDX;
    var calloutX = padL + g.calloutDX;
    var calloutY = startY - g.pinHaloR - g.calloutGap - g.calloutH;
    var badgeX = g.badgeX, badgeY = g.badgeY, badgeW = g.badgeW, badgeH = g.badgeH;
    var calloutHtml = '<div class="fq-chart-callout fq-chart-yourlevel" style="left:' + (calloutX / W * 100).toFixed(3) + '%;top:' + (calloutY / H * 100).toFixed(3) + '%;background:' + t.calloutBg + ';color:' + t.levelColor + '">' + esc(FLOW.chart.calloutLabel || 'Your level') + '</div>';
    return '<div class="fq-rescard fq-chart-card"><div class="fq-chart-box"><svg class="fq-chart-svg" viewBox="0 0 ' + W + ' ' + H + '">' +
      '<defs><linearGradient id="' + ID_AREA + '" gradientUnits="userSpaceOnUse" x1="0" y1="' + g.gradTop + '" x2="0" y2="' + g.gradBottom + '">' +
      '<stop offset="0%" stop-color="#3B7DDD" stop-opacity="1"/>' +
      '<stop offset="100%" stop-color="#3B7DDD" stop-opacity="0"/>' +
      '</linearGradient>' +
      '<linearGradient id="' + ID_TRACE + '" gradientUnits="userSpaceOnUse" x1="' + endX + '" y1="' + endY + '" x2="' + startX + '" y2="' + startY + '">' +
      '<stop offset="0%" stop-color="#A1C4FF"/>' +
      '<stop offset="100%" stop-color="#004AAD"/>' +
      '</linearGradient>' +
      /* CSS linear-gradient(168.62deg) mapped onto the badge box */
      '<linearGradient id="' + ID_BADGE + '" gradientUnits="objectBoundingBox" x1="0.441" y1="-0.215" x2="0.559" y2="1.215">' +
      '<stop offset="0%" stop-color="#A1C4FF"/>' +
      '<stop offset="100%" stop-color="#004AAD"/>' +
      '</linearGradient></defs>' +
      grid + labels +
      '<path class="fq-chart-area" d="' + areaPath + '" fill="url(#' + ID_AREA + ')"/>' +
      '<path class="fq-chart-trace" style="stroke:url(#' + ID_TRACE + ')" d="' + path + '"/>' +
      '<circle class="fq-chart-pin" cx="' + pinX + '" cy="' + startY + '" r="' + g.pinHaloR + '" fill="' + t.levelColor + '" opacity="0.3"/>' +
      '<circle class="fq-chart-pulse" cx="' + pinX + '" cy="' + startY + '" r="' + g.pinR + '" fill="' + t.levelColor + '"/>' +
      '<circle class="fq-chart-pin" cx="' + pinX + '" cy="' + startY + '" r="' + g.pinR + '" fill="' + t.levelColor + '"/>' +
      '<g class="fq-chart-callout fq-chart-callout--end"><rect class="fq-chart-badge-rect" x="' + (badgeX + 1) + '" y="' + (badgeY + 1) + '" rx="' + (badgeH / 2) + '" ry="' + (badgeH / 2) + '" width="' + (badgeW - 2) + '" height="' + (badgeH - 2) + '" fill="url(#' + ID_BADGE + ')"/>' +
      '<text x="' + (badgeX + badgeW / 2) + '" y="' + (badgeY + badgeH / 2) + '" text-anchor="middle" dominant-baseline="central" class="fq-chart-badge-text">' + esc(t.lift) + '</text></g>' +
      '<circle class="fq-chart-pin fq-chart-pin--end" cx="' + g.endDotX + '" cy="' + endY + '" r="' + g.endHaloR + '" fill="#3B7DDD"/>' +
      '<circle class="fq-chart-pin fq-chart-pin--end" cx="' + g.endDotX + '" cy="' + endY + '" r="' + g.endR + '" fill="#F1F5F9"/>' +
      '</svg>' + calloutHtml + '</div></div>';
  }

  function resultGaugeScreen(step) {
    var t = TIERS[state.tier];
    return '<div class="fq-result-head ' + t.cls + '">' +
      '<span class="fq-badge-pill fq-fade-up fq-d1">' + esc(step.eyebrow) + '</span>' +
      '<h1 class="fq-h1 fq-fade-up fq-d2">' + esc(step.title) + '</h1>' +
      '</div>' +
      '<div class="fq-result-col ' + t.cls + '">' +
      '<div class="fq-fade-up fq-d3">' + gaugeHtml(t) + '</div>' +
      '<div class="fq-fade-up fq-d4"><div class="fq-alert fq-tier-accent"><span class="fq-alert-icon"></span><div class="fq-alert-body"><p class="fq-alert-title">' + esc(t.alertTitle) + '</p><p class="fq-alert-text">' + esc(t.alertText) + '</p></div></div></div>' +
      '<div class="fq-stats fq-fade-up fq-d5">' +
      '<div class="fq-rescard fq-stat"><span class="fq-stat-label">STATUS</span><span class="fq-stat-value fq-tier-accent">' + esc(t.statusValue) + '</span><span class="fq-stat-sub">' + esc(t.statusSub) + '</span></div>' +
      '<div class="fq-rescard fq-stat"><span class="fq-stat-label">RISK LEVEL</span><span class="fq-stat-value fq-tier-accent">' + esc(t.riskValue) + '</span><span class="fq-stat-sub">' + esc(t.riskSub) + '</span></div>' +
      '<div class="fq-rescard fq-stat"><span class="fq-stat-label">POTENTIAL</span><span class="fq-stat-value" style="color:' + t.potentialColor + '">' + esc(t.potential) + '</span><span class="fq-stat-sub">IMPROVEMENT</span></div>' +
      '</div>' +
      '<div class="fq-fade-up fq-d6"><div class="fq-rescard fq-means"><h3>' + esc(step.meansTitle || 'What This Means For You') + '</h3><div class="fq-means-body"><p>' + esc(t.meansIntro) + '</p><ul>' +
      t.meansBullets.map(function (b) { return '<li>' + esc(b) + '</li>'; }).join('') +
      '</ul><p>' + t.meansClosing + '</p></div></div></div>' +
      '<div class="fq-fade-up fq-d7" style="display:flex;justify-content:center;"><button type="button" class="fq-cta fq-cta--xl" data-continue>' + esc(step.cta) + '</button></div>' +
      '</div>';
  }

  function resultChartScreen(step) {
    var t = TIERS[state.tier];
    return '<div class="fq-result-head ' + t.cls + '">' +
      '<span class="fq-badge-pill fq-fade-up fq-d1">' + esc(step.eyebrow) + '</span>' +
      '<h1 class="fq-h1 fq-fade-up fq-d2">' + esc(step.title) + '</h1>' +
      '<p class="fq-sub fq-fade-up fq-d3">' + esc(step.sub) + '</p>' +
      '</div>' +
      '<div class="fq-result-col fq-result-col--r2 ' + t.cls + '">' +
      '<div class="fq-fade-up fq-d4">' + chartHtml(t) + '</div>' +
      '<div class="fq-milestones fq-fade-up fq-d5"><h3 class="fq-milestones-title">' + esc(step.milestonesTitle || 'Expected Milestones') + '</h3>' +
      t.milestones.map(function (m, i) {
        var last = i === t.milestones.length - 1;
        return '<div class="fq-rescard fq-milestone fq-tier-accent"><div class="fq-ms-iconcol"><span class="fq-ms-dot"></span>' + (last ? '' : '<span class="fq-ms-line"></span>') + '</div><div class="fq-milestone-body"><h4><span>' + esc(m.label) + '</span>' + esc(m.title) + '</h4><p>' + esc(m.text) + '</p></div></div>';
      }).join('') + '</div>' +
      '<div class="fq-fade-up fq-d6" style="display:flex;justify-content:center;"><button type="button" class="fq-cta" data-continue>' + esc(step.cta) + '</button></div>' +
      '</div>';
  }

  var RENDERERS = {
    hero: heroScreen,
    question: questionScreen,
    interstitial: interstitialScreen,
    ring_loader: ringLoaderScreen,
    step_loader: stepLoaderScreen,
    result_gauge: resultGaugeScreen,
    result_chart: resultChartScreen
  };

  function progressFor(idx) {
    var pos = Math.min(PROGRESS_POS[idx] || 0, PROGRESS_TOTAL);
    return Math.min(100, Math.round((pos / PROGRESS_TOTAL) * 10000) / 100);
  }

  function render() {
    var step = STEPS[state.screen];
    if (!step) return;
    var stage = root.querySelector('[data-fq-stage]');
    var fill = root.querySelector('[data-fq-progress]');
    var bar = root.querySelector('.fq-progress-wrap');
    stage.innerHTML = RENDERERS[step.type](step);
    stage.setAttribute('data-screen', String(state.screen));
    stage.setAttribute('data-step-type', step.type);
    stage.setAttribute('data-step-id', step.id);
    var showProgress = !!PROGRESS_TYPES[step.type] && step.type !== 'ring_loader';
    if (bar) bar.classList.toggle('is-hidden', !showProgress);
    if (fill) fill.style.width = progressFor(state.screen) + '%';
    window.scrollTo(0, 0);
    track('quiz_step_viewed', { step_index: state.screen, step_id: step.id });

    if (step.type === 'ring_loader') runAnalyzeLoader(step);
    if (step.type === 'step_loader') runStepLoader(step);
    if (step.type === 'result_gauge') track('quiz_result_viewed', { tier: state.tier, score: state.score });
  }

  function goTo(idx) {
    state.screen = clampScreen(idx);
    render();
  }

  function runAnalyzeLoader(step) {
    var ring = root.querySelector('[data-ring]');
    var value = root.querySelector('[data-ring-value]');
    var dots = root.querySelectorAll('.fq-dot');
    if (!ring || !value) return;
    var c = ringCirc(ring);
    var start = null;
    var DURATION = step.duration || 4000;
    function frame(ts) {
      if (!start) start = ts;
      var p = Math.min(1, (ts - start) / DURATION);
      value.innerHTML = ringValueHtml(Math.round(p * 100) + '%');
      ring.style.strokeDashoffset = c * (1 - p);
      dots.forEach(function (d, i) {
        d.classList.toggle('is-active', i <= Math.floor(p * 2.99));
      });
      if (p < 1) requestAnimationFrame(frame);
      else setTimeout(function () { goTo(state.screen + 1); }, 400);
    }
    requestAnimationFrame(frame);
  }

  function runStepSequence(stepsDef, opts, onDone) {
    var container = root.querySelector('[data-steps]');
    if (!container) return;
    var total = stepsDef.length;
    var idx = 0;
    function paint() {
      container.innerHTML = stepsDef.map(function (s, i) {
        return stepCard(s, i < idx ? 'done' : i === idx ? 'active' : 'pending', opts.ring);
      }).join('');
      container.querySelectorAll('.fq-step').forEach(function (el, i) {
        if (i < idx) el.classList.add('is-done');
        if (i === idx) el.classList.add('is-active');
      });
      if (opts.counter) {
        var cnt = root.querySelector('[data-step-count]');
        var prog = root.querySelector('[data-step-progress]');
        if (cnt) cnt.textContent = 'Step ' + Math.min(idx + 1, total) + ' of ' + total;
        if (prog) prog.style.width = (Math.min(idx + 1, total) / total) * 100 + '%';
      }
      if (opts.ring) {
        var value = root.querySelector('[data-ring-value]');
        var ring = root.querySelector('[data-ring]');
        if (value) value.textContent = Math.min(idx + 1, total) + '/' + total;
        if (ring) {
          var c = ringCirc(ring);
          ring.style.strokeDashoffset = c * (1 - Math.min(idx + 1, total) / total);
          ring.style.transition = 'stroke-dashoffset 600ms ease';
        }
      }
    }
    paint();
    var timer = setInterval(function () {
      idx++;
      if (idx >= total) {
        clearInterval(timer);
        paint();
        setTimeout(onDone, 600);
        return;
      }
      paint();
    }, 1500);
  }

  function runStepLoader(step) {
    var opts = step.variant === 'ring' ? { ring: true } : { counter: true };
    if (step.onDone === 'redirect') {
      track('quiz_redirect', { tier: state.tier, url: REDIRECT_URL });
      runStepSequence(step.steps, opts, function () {
        if (REDIRECT_URL) window.location.href = REDIRECT_URL;
      });
      return;
    }
    runStepSequence(step.steps, opts, function () {
      if (step.onDone === 'score') {
        calcTier();
        track('quiz_completed', { total_score: state.score, tier: state.tier });
        sendToKlaviyo();
      }
      goTo(state.screen + 1);
    });
  }

  root.addEventListener('click', function (e) {
    var opt = e.target.closest('.fq-option');
    if (opt && !opt.disabled) {
      var q = opt.getAttribute('data-q');
      var i = parseInt(opt.getAttribute('data-i'), 10);
      if (!state.started) {
        state.started = true;
        track('quiz_started', {});
      }
      state.answers[q] = i;
      state.answerText[q] = opt.textContent.trim();
      calcTier();
      track('quiz_question_answered', { question_id: questionId(q), question_key: q, answer_index: i });
      root.querySelectorAll('.fq-option').forEach(function (b) { b.disabled = true; });
      opt.classList.add('is-selected');
      setTimeout(function () { goTo(state.screen + 1); }, ADVANCE_DELAY);
      return;
    }
    var cont = e.target.closest('[data-continue]');
    if (cont) {
      track('quiz_cta_clicked', { screen: state.screen, tier: state.tier });
      goTo(state.screen + 1);
    }
  });

  render();
})();
